import { render, staticRenderFns } from "./ResidentMultipleRegister.vue?vue&type=template&id=012cae12&scoped=true&lang=pug"
import script from "./ResidentMultipleRegister.vue?vue&type=script&lang=ts"
export * from "./ResidentMultipleRegister.vue?vue&type=script&lang=ts"
import style0 from "./ResidentMultipleRegister.vue?vue&type=style&index=0&id=012cae12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012cae12",
  null
  
)

export default component.exports